import script from "./CreateEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEvent.vue?vue&type=script&setup=true&lang=js"

import "./CreateEvent.vue?vue&type=style&index=0&id=063da2db&lang=css"
import "./CreateEvent.vue?vue&type=style&index=1&id=063da2db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-063da2db"]])

export default __exports__